export default __webpack_public_path__ + "static/media/TitlePage_HeaderImage.94266c4f.jpg";